import script from "./CustomerFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerFilter.vue?vue&type=script&setup=true&lang=js"

import "./CustomerFilter.vue?vue&type=style&index=0&id=7638ecb1&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7638ecb1"]])

export default __exports__